import { SFH_RESTRICTION_SYNC } from '../../constants/localStorage';
import { storeInLocalStorage } from './localStorageHelper';

/**
 * Notify other browser tabs that Sell From Home may now be restricted
 * (e.g. after SSNTooManyAttempts). Other tabs listen via the `storage`
 * event and refetch account settings so Redux picks up RestrictSellFromHome.
 */
export function broadcastSellFromHomeRestrictionSync(accountUid) {
  if (!accountUid) return;

  storeInLocalStorage(SFH_RESTRICTION_SYNC, {
    accountUid,
    at: Date.now(),
  });
}

export function parseSellFromHomeRestrictionSync(rawValue) {
  if (!rawValue) return null;

  try {
    const parsed =
      typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
    if (!parsed || typeof parsed !== 'object' || !parsed.accountUid) {
      return null;
    }
    return parsed;
  } catch (error) {
    return null;
  }
}
